export const hasValidHTMLContent = (html: string): boolean => {
  if (!html || typeof html !== 'string') return false;
  const cleanHtml = html.trim();
  if (!cleanHtml) return false;
  if (cleanHtml === '<p></p>' || cleanHtml === '<p><br></p>' || cleanHtml === '<p><br/></p>' || cleanHtml === '<br>' || cleanHtml === '<br/>') return false;
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = cleanHtml;
  const textContent = (tempDiv.textContent || tempDiv.innerText || '').trim();
  return textContent.length > 0;
};
